export default from './category-page-header';



// WEBPACK FOOTER //
// ./app/containers/category-page-header/index.js